import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>Our Software Services Cater to Various Industries</h2>
            <p>
              We excel in developing versatile software solutions using advanced
              technology stacks and frameworks to satisfy the specific needs of
              various sectors.
            </p>
            <p>
              Our solutions seamlessly integrate with your company's needs,
              providing efficient and user-friendly digital solutions for
              long-term success across a wide range of industries.
            </p>
            <p>Here are the several industries that we serve</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Project!
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3  my-auto"
          >
            <div className="industry_scroll">
              <h3>Business & Corporate</h3>
              <h3>Healthcare</h3>
              <h3>Music</h3>
              <h3>Logistics</h3>
              <h3>Entertainment</h3>
              <h3>Retail</h3>
              <h3>Automotive</h3>
              <h3>E-commerce</h3>
              <h3>Real Estate</h3>
              <h3>Education</h3>
              <h3>Fintech</h3>
              <h3>IT Staff Augmentation</h3>
              <h3>On-Demand</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
